import axios from 'axios';
import dayjs from 'dayjs';
import axiosService from '@Lib/axiosService';
import { getBarcodeAuthToken } from '@Utils/barcodePrint';

const url = `${process.env.URL}`;

export const getCustomers = (params) => {
  const { projectId, tabParam, ...restParams } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/customers${tabParam ?? ''}`, restParams)
    .then((res) => res.data);
};

export const addCustomer = (params) => {
  const { projectId, ...restParams } = params;
  return axiosService
    .post(`${url}/projects/${projectId}/customers`, restParams)
    .then((res) => res.data);
};

export const getCustomerDetail = (params) => {
  const { projectId, customerId } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/customers/${customerId}`)
    .then((res) => res.data.data);
};

export const editCustomer = (params) => {
  const { projectId, customerId, ...restParams } = params;
  return axiosService
    .put(`${url}/projects/${projectId}/customers/${customerId}`, restParams)
    .then((res) => res.data);
};

export const getCustomerLevels = () => {
  return axiosService.get(`${url}/customerLevels`).then((res) => res.data);
};

export const getCustomerGroups = () => {
  return axiosService.get(`${url}/customerGroups`).then((res) => res.data);
};

export const deleteCustomer = ({ projectId, customerId }) => {
  return axiosService
    .delete(`${url}/projects/${projectId}/customers/${customerId}`)
    .then((res) => res.data);
};

export const getCustomersExportUrl = (params = {}) => {
  const { projectId } = params;
  const resolvedProjectId = projectId ?? 0;
  const query = new URLSearchParams();
  const ignoredKeys = ['projectId', 'page', 'per_page'];

  Object.entries(params).forEach(([key, value]) => {
    if (ignoredKeys.includes(key) || value === undefined || value === null || value === '') {
      return;
    }

    query.set(key, String(value));
  });

  return `${url}/projects/${resolvedProjectId}/customers/export${
    query.toString() ? `?${query.toString()}` : ''
  }`;
};

export const downloadCustomersExport = async (params = {}) => {
  const token = getBarcodeAuthToken();

  if (!token) {
    throw new Error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại');
  }

  let response;

  try {
    response = await axios.get(getCustomersExportUrl(params), {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
  } catch (error) {
    const errorBlob = error?.response?.data;

    if (errorBlob instanceof Blob && errorBlob.type?.includes('application/json')) {
      const errorPayload = JSON.parse(await errorBlob.text());
      throw new Error(errorPayload?.message || 'Không thể xuất Excel danh sách khách hàng');
    }

    throw error;
  }

  const blob = new Blob([response.data], {
    type:
      response.headers['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = downloadUrl;
  link.download = `danh-sach-khach-hang-${dayjs().format('YYYYMMDD-HHmmss')}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};
